import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";

import CreateCampaignForm from "../components/CreateCampaignForm";

function CreateCampaignPage() {
  const { t, i18n } = useTranslation();
  useEffect(() => {
    const savedLanguage = Cookies.get("language");
    if (savedLanguage) {
      i18n.changeLanguage(savedLanguage);
    }
  }, [i18n]);
  return (
    <div className="md:flex md:justify-center">
      <div className="p-3 md:w-deflaut md:flex">
        <div className="w-full">
          <a href="/Campaign" className="no-underline">
            <p className="text-header font-bold my-4 text-ft-light hover:text-ft hover:underline">
              {t("campaignPage.newCampaign")}
            </p>
          </a>
          <CreateCampaignForm />
        </div>
      </div>
    </div>
  );
}

export default CreateCampaignPage;
